import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { setUserId, clearUserId, trackPageView } from './googleAnalytics';
import { useUser } from '../contexts/UserContext';

export const RouteAnalytics = () => {
  const location = useLocation();
  const { user } = useUser();
  const lastSentPath = useRef<string | null>(null);

  // Keep GA's user_id in sync with your app user
  useEffect(() => {
    if (user?.id) {
      setUserId(String(user.id));
    } else {
      clearUserId();
    }
  }, [user?.id]);

  // Send a page_view on route changes (inherits current user_id if set)
  useEffect(() => {
    if (lastSentPath.current !== location.pathname) {
      trackPageView(location.pathname, document.title);
      lastSentPath.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
};
